import './node-attachement.css';

import React from 'react';

import { PositionedTree } from '../../../pages/mindmap/types';
import { FileAttachementChip } from './file-attachement-chip';
import { LinkAttachementChip } from './link-attachement-chip';

interface NodeAttachementsProps {
  node: PositionedTree;
  selected: boolean;
}

export const NodeAttachements = ({ node, selected }: NodeAttachementsProps) => {
  return (
    <div
      style={{
        borderTop: '1px solid #dee2e6',
        padding: 12,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
      }}
    >
      {node.attachements?.map((attachement) => {
        const { id, type } = attachement;

        switch (type) {
          case 'file': {
            return (
              <React.Fragment key={id}>
                <FileAttachementChip attachement={attachement} selected={selected} nodeId={node.id} />
              </React.Fragment>
            );
          }
          case 'link': {
            return (
              <React.Fragment key={id}>
                <LinkAttachementChip attachement={attachement} selected={selected} nodeId={node.id} />
              </React.Fragment>
            );
          }
        }
      })}
    </div>
  );
};
